import $ from 'jquery'
import StickyMessagesView from 'component/sticky_flash_message'

export default new StickyMessagesView({ el: $('.js-sticky-flash-message') })
